import * as R from 'ramda'
import React, { useState } from 'react'
import Link from 'next/link'
import styled, { css } from 'styled-components'
import NProgress from 'nprogress'
import { useSnackbar } from 'notistack'
import Feed from 'routes/Home/components/Feed'
import { useSession } from 'context/Session'
import { PostInput } from 'components/collections/Post'
import { getCloudFlareImgVariant } from 'components/helpers/withSizes'
import { Button, Modal, FollowButton } from 'components/elements'

import { approveMember, kickMember } from '../modules/datasource'

export const StyledFeed = styled(Feed)``
export const StyledPost = styled(PostInput)`
  padding-bottom: 30px;
  ${({ theme }) => theme.media.phone} {
    padding-top: 30px;
  }
`

// export const Container = styled.div`
//   display: flex;
//   flex-direction: column;
//   width: 100%;
//   padding: 72px 160px 0;
//   justify-content: center;
//   align-items: center;
//   ${({ theme }) => theme.media.desktop} {
//     padding: 0 60px 0;
//   }
//   ${({ theme }) => theme.media.tablet} {
//     padding: 0 32px 0;
//     flex-direction: column;
//   }
//   ${({ theme }) => theme.media.phone} {
//     padding: 0 16px 0;
//     flex-direction: column;
//   }
// `
// export const Content = styled.div`
//   display: flex;
//   justify-content: space-between;
//   height: 100%;
//   width: 100%;
//   max-width: 1440px;
//   padding: 16px 0;
//   ${({ theme }) => theme.media.tabletMini} {
//     flex-direction: column;
//   }
// `

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 32px 160px 0;
  ${({ theme }) => theme.media.desktop} {
    padding: 32px 60px 0;
  }
  ${({ theme }) => theme.media.tablet} {
    padding: 56px 32px 0;
    flex-direction: column;
  }
  ${({ theme }) => theme.media.phone} {
    padding: 0 16px 24px 0;
    flex-direction: column;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  height: 100%;
  width: 100%;
  max-width: 1440px;
  ${({ theme }) => theme.media.tabletMini} {
    flex-direction: column;
  }
`

export const Header = styled.div`
  width: 100%;
  max-width: 1440px;
  display: flex;
  ${({ theme }) => theme.media.phone} {
    padding: 32px 16px 0;
  }
`

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const GroupAvatarContainer = styled.div`
  height: 64px;
  width: 64px;
  min-height: 64px;
  min-width: 64px;
  max-height: 64px;
  max-width: 64px;
  position: relative;
  margin-right: 16px;

  ${({ theme }) => theme.media.phone} {
    margin-bottom: 34px;
  }
`
export const GroupAvatar = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 50px;
  position: relative;
  overflow: hidden;
  text-transform: uppercase;

  ${({ theme }) => theme.media.phone} {
    font-size: 40px;
  }
`

export const ImgProfile = styled.div`
  height: 100%;
  width: 100%;
  ${({ src }) =>
    src &&
    css`
      background-image: ${`url(${src})`};
      background-size: cover;
      background-position: center;
    `};
`
export const Title = styled.div`
  ${({ theme }) => theme.font.h3};
  margin-bottom: 14px;
`
export const GroupInfo = styled.div`
  display: flex;
  align-items: center;
  .MuiAvatar-root {
    background-color: ${({ theme }) => theme.colors.primary} !important;
  }
  ${({ theme }) => theme.media.tablet} {
    flex-direction: column;
    align-items: flex-start;
  }
`
export const MembersWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
export const GroupDesc = styled.div`
  ${({ theme }) => theme.font.h5};
  margin-left: 20px;
  ${({ theme }) => theme.media.tablet} {
    margin-top: 20px;
    margin-left: 0;
  }
`
export const FollowWrapper = styled.div`
  width: fit-content;
  margin-top: 20px;
  display: flex;
  align-items: center;
`

const StyledOther = styled.div`
  display: flex;
  width: 100%;
  & + & {
    margin-top: 16px;
  }
`
const OtherImg = styled.div`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primaryL};
  border-radius: 50%;
  height: 30px;
  width: 30px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
  height: 48px;
  width: 48px;
  min-height: 48px;
  min-width: 48px;
  text-transform: uppercase;
`
const StyledImg = styled.img`
  height: 100%;
  width: 100%;
  object-position: center;
  object-fit: cover;
`

const OtherDesc = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const StyledName = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`
const OtherSingleLine = styled.div`
  color: ${({ theme }) => theme.colors.grey};
  ${({ theme }) => theme.font.body2}
  max-width: 416px;
`
const MemberActions = styled.div`
  display: flex;
  align-items: center;
`
const StyledButton = styled.div`
  padding: 4px 12px;
  cursor: pointer;
  border: solid 1px transparent;
  ${({ theme }) => theme.font.body2}
  border-radius: 13px;

  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.grey};
  border-color: ${({ theme }) => theme.colors.grey};

  & + & {
    margin-left: 8px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.grey};
    border-color: ${({ theme }) => theme.colors.grey};
  }
`
const DeleteContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 416px;
  margin: 0 auto;
  height: 100%;
  min-height: 300px;
  max-height: 100vh;
  ${({ theme }) => theme.media.phone} {
    padding: 0 15px;
  }
`
const DeleteTitle = styled.div`
  ${({ theme }) => theme.font.h3}
  margin-bottom: 32px;
  text-align: center;
  max-width: 478px;

  ${({ theme }) => theme.media.phone} {
    br {
      display: none;
    }
  }
`
const DeleteButton = styled(Button)`
  & + & {
    margin-top: 8px;
  }
`
export const Member = props => {
  const {
    data: { profile, type, isFollowing },
    groupId,
    isAdmin,
  } = props
  const { accessToken, user } = useSession()
  const { username, profileImage, singleLineStatement } = profile
  const [userType, setUserType] = useState(type)
  const [modalConfig, setModalConfig] = useState(null)
  const [isOpen, setOpen] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const authorPath = `/p/${username}`

  const sessionUsername = user?.profile?.username

  const approveUser = async () => {
    setModalConfig({
      text: 'You want to approve this user?',
      onConfirm: async () => {
        try {
          NProgress.start()
          setUserType('Member')
          await approveMember({ accessToken, groupId, userId: profile?.id })
          enqueueSnackbar('User has been approved', { variant: 'success' })
        } catch (e) {
          enqueueSnackbar(e.response?.data?.message, { variant: 'error' })
        }
        NProgress.done()
      },
    })
    setOpen(true)
  }

  const kickUser = async () => {
    setModalConfig({
      text: 'You want to kick this user?',
      onConfirm: async () => {
        try {
          NProgress.start()
          setUserType('Kicked')
          await kickMember({ accessToken, groupId, userId: profile?.id })
          enqueueSnackbar('User has been kicked', { variant: 'success' })
        } catch (e) {
          enqueueSnackbar(e.response?.data?.message, { variant: 'error' })
        }
        NProgress.done()
      },
    })
    setOpen(true)
  }

  return !username ? null : (
    <StyledOther>
      <Link href={authorPath} passHref>
        <a>
          <OtherImg>
            {profileImage ? (
              <StyledImg
                src={getCloudFlareImgVariant(profileImage, {
                  default: 'profileSmall',
                })}
              />
            ) : (
              R.head(username || '')
            )}
          </OtherImg>
        </a>
      </Link>
      <OtherDesc>
        <StyledName>
          <Link href={authorPath} passHref>
            <a>{username}</a>
          </Link>
          <MemberActions>
            {sessionUsername && username !== sessionUsername && (
              <FollowButton
                isFollowing={isFollowing}
                style={{ marginRight: 10 }}
                username={username}
                // onClick={toggleFollow}
              />
            )}
            {isAdmin && !['Kicked', 'Admin'].includes(userType) && (
              <>
                {userType === 'Pending' && (
                  <StyledButton onClick={approveUser}>Approve</StyledButton>
                )}
                <StyledButton onClick={kickUser}>Kick</StyledButton>
              </>
            )}
          </MemberActions>
        </StyledName>
        <OtherSingleLine>{singleLineStatement}</OtherSingleLine>
      </OtherDesc>
      <Modal
        isOpen={isOpen}
        close={() => setOpen(false)}
        closeOnOutside={false}
      >
        <DeleteContent>
          <DeleteTitle>{modalConfig?.text}</DeleteTitle>
          <DeleteButton
            type="button"
            onClick={async () => {
              await modalConfig?.onConfirm()

              setOpen(false)
            }}
          >
            Yes
          </DeleteButton>
          <DeleteButton
            type="button"
            variant="text"
            onClick={() => setOpen(false)}
          >
            No
          </DeleteButton>
        </DeleteContent>
      </Modal>
    </StyledOther>
  )
}

export const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  ${({ theme }) => theme.media.phone} {
    padding: 15px 15px 0;
  }
`

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.colors.primary};
`

export const CustomWrapper = css`
  & + & {
    margin-top: 10px !important;
    padding-top: 10px !important;
  }
`
